import { parse } from 'date-fns';

export class Utilities {
  static clone(object: any) {
    return object ? JSON.parse(JSON.stringify(object)) : object;
  }

  static numberToWord(n: number): string {
    if (n < 0) return '';
    const single_digit = ['', 'one', 'two', 'three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const double_digit = [
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ];
    if (n === 0) return 'Zero';
    function translate(n) {
      let word = '';
      if (n < 10) {
        word = single_digit[n] + ' ';
      } else if (n < 20) {
        word = double_digit[n - 10] + ' ';
      }
      return word;
    }
    const result = translate(n);
    return result.trim();
  }

  static timeToMinutes(timeString) {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const totalMinutes = hours * 60 + minutes + Math.floor(seconds / 60);

    return totalMinutes;
  }

  static convertToRoundedHour(timeString) {
    const date = parse(timeString, 'HH:mm:ss', new Date());
  
    const hours = date.getHours();
    const minutes = date.getMinutes();
  
    const roundedHours = minutes > 0 ? hours + 1 : hours;
  
    return roundedHours === 0 ? 1 : roundedHours;
  }
}
